import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import LockIcon from '@mui/icons-material/Lock';
import PublicIcon from '@mui/icons-material/Public';
import { Box, Link, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

import analysisPropTypes from '../../proptypes/analysis';
import Status from '../common/Status';
import TypographyWithIcon from '../common/TypographyWithIcon';
import AnalysisTitle from './AnalysisTitle';

const AnalysisHeaderText = ({
    analysisReference,
    analysis,
    actualCommitMessage,
    refreshAnalysis,
    isRenamingModalOpened,
    publicVisibility,
    isLoggedIn,
}) => {
    return (
        <Box display="flex" alignItems="center" flex={1} maxWidth="100%">
            <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                justifyContent="center"
                maxWidth="100%"
            >
                <Box display="flex" alignItems="center" maxWidth="100%">
                    <AnalysisTitle
                        incrementalId={analysis.incrementalId}
                        gitCommitMessage={actualCommitMessage}
                        projectId={analysis.project.id}
                        analysisId={analysis.id}
                        refreshAnalysis={refreshAnalysis}
                        isRenamingModalOpened={isRenamingModalOpened}
                    />

                    <Status status={analysis.status} />

                    {isLoggedIn && (
                        <Tooltip
                            title={`${publicVisibility ? 'Public' : 'Private'} analysis`}
                        >
                            {publicVisibility ? <PublicIcon /> : <LockIcon />}
                        </Tooltip>
                    )}
                </Box>
                {analysisReference && (
                    <Box display="flex" gap={2}>
                        <TypographyWithIcon
                            icon={<CompareArrowsIcon fontSize="small" />}
                            variant="subtitle1"
                        >
                            Compare with:
                        </TypographyWithIcon>
                        <Link
                            href={
                                analysisReference.id
                                    ? `/analyses/${analysisReference.id}`
                                    : '#'
                            }
                            underline="none"
                            color="secondary"
                        >
                            <AnalysisTitle
                                incrementalId={analysisReference.incrementalId}
                                gitCommitMessage={analysisReference.gitCommitMessage}
                                variant="subtitle1"
                            />
                        </Link>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

AnalysisHeaderText.propTypes = {
    analysisReference: analysisPropTypes,
    analysis: PropTypes.object,
    actualCommitMessage: PropTypes.string,
    refreshAnalysis: PropTypes.func,
    isRenamingModalOpened: PropTypes.func,
    publicVisibility: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
};

export default AnalysisHeaderText;
